import React, { useEffect, useState, PropsWithChildren } from "react";
import { IdSessionContext } from "./App";

type Props = {}; // Adjust as needed

function generateGUID() {
  // Returns a RFC4122 version 4 compliant UUID
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

export function IdSession(props: PropsWithChildren<Props>) {
  const { idSession, setIdSession } = React.useContext(IdSessionContext);

  // Generate or retrieve a persistent GUID from localStorage
  useEffect(() => {
    if (!idSession) {
      let storedId = localStorage.getItem("idSession");
      if (!storedId) {
        storedId = generateGUID();
        localStorage.setItem("idSession", storedId);
        console.log('new GENERATED SESSION id', storedId)
      }
      console.log('returning SESSION id', storedId)
      setIdSession(storedId);
    }
  }, [idSession, setIdSession]);

  // You can remove all Supabase code and related effects

  return null; // or <></>
}